module.exports = __webpack_public_path__ + "static/media/tick-orange.47afd014.svg";